































import { defineComponent } from '@vue/composition-api';
import Tab from './Tab.vue';

export default defineComponent({
    name: 'BaseTabs',
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        activeTab: {
            type: Number,
            required: true,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        breadcrumbMode: {
            type: Boolean,
            default: true,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    components: { Tab },
    setup(props, { emit }) {
        // In breadcrumb mode only completed steps can be navigated back to; upcoming steps stay inert.
        const isClickable = (index: number) => {
            if (!props.clickable) return false;
            return props.breadcrumbMode ? index < props.activeTab : index !== props.activeTab;
        };
        const tabClicked = (tabIndex: number) => {
            emit('click', tabIndex);
        };
        return { isClickable, tabClicked };
    },
});
